import { Routes, Route, Navigate } from 'react-router-dom'
import { Container } from '@mui/material'
import Layout from './components/Layout'
import AuthWrapper from './components/AuthWrapper'
import Login from './pages/Login'
import Home from './pages/Home'
import LightspeedProducts from './pages/lightspeed/Products'
import LightspeedSales from './pages/lightspeed/Sales'
import LightspeedCustomers from './pages/lightspeed/Customers'
import LightspeedRetailerSetup from './pages/lightspeed/RetailerSetup'
import LightspeedBulkSales from './pages/lightspeed/BulkSales'
import { FranchiseProvider } from './contexts/FranchiseContext'
import { AuthProvider } from './contexts/AuthContext'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public login route */}
        <Route path="/login" element={<Login />} />
        
        {/* Protected routes */}
        <Route path="/*" element={
          <AuthWrapper>
            <FranchiseProvider>
              <Layout>
                <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/lightspeed/products" element={<LightspeedProducts />} />
                    <Route path="/lightspeed/sales" element={<LightspeedSales />} />
                    <Route path="/lightspeed/customers" element={<LightspeedCustomers />} />
                    <Route path="/lightspeed/retailer-setup" element={<LightspeedRetailerSetup />} />
                    <Route path="/lightspeed/bulk-sales" element={<LightspeedBulkSales />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Container>
              </Layout>
            </FranchiseProvider>
          </AuthWrapper>
        } />
      </Routes>
    </AuthProvider>
  )
}

export default App